import { Box, Grid2 } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import { useTheme } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import useMediaQuery from '@mui/material/useMediaQuery';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import usercalls from "../../Axios";
import consts from "../../constant";
import Header from '../Header/Header';
const drawerWidth = 260;


const P2pHistory = () => {

    const theme = useTheme();
    const lg = useMediaQuery(theme.breakpoints.up('lg'));

    const back = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const tradeType = queryParams.get("type"); // "buy" or "sell"
    const path = usercalls()

    const Navigate = useNavigate();
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [totalPage, setTotalPages] = useState(1)
    const [p2p, setP2p] = useState([]);



    const getPp2 = async () => {
        try {
            const url = `${consts.BackendUrl}/admin/getp2ps`;
            const payload = { type: tradeType }
            const response = await path.postCall({ url, payload });
            const result = await response.json();

            if (result?.success) {
                setP2p(result?.result)
                setTotalPages(Math.ceil(result?.result.length / limit));
            }
        } catch (error) {
            console.log("🚀 ~ getAlUser ~ error", error)
        }
    }


    useEffect(() => {
        if (localStorage.getItem("adminToken")) {
            getPp2();
        } else {
            Navigate(`/${consts.route + '/login'}`);
        }
    }, [limit, page, tradeType]);


    return (
        <div className="UserList">
            <ToastContainer />
            <Box sx={{ display: lg ? 'flex' : 'block' }}>
                <Header />
                <Box
                    component="main"
                    sx={{ flexGrow: 1, p: 5, width: { lg: `calc(100 % - ${drawerWidth}px)` }, marginTop: '50px' }}
                >
                    <Grid2 container spacing={2}>
                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>

                            <div className="custom_table">

                                <TableContainer>
                                    <Table aria-label="user table">
                                        <TableHead>
                                            <TableRow>
                                                {["S.No", "Date/Time", "Price", "Amount", "User Name", "Type", "Remaining", "Status"].map((header) => (
                                                    <TableCell key={header} align="center" sx={{ fontWeight: "bold" }}>
                                                        {header}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {p2p.length > 0 ?
                                                p2p
                                                    .slice((page - 1) * limit, page * limit)
                                                    .map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center">{limit * (page - 1) + index + 1}</TableCell>
                                                            <TableCell align="center"> {row?.createdAt?.replace("T", " ").split(".")[0]} </TableCell>
                                                            <TableCell align="center"> {row?.price} </TableCell>
                                                            <TableCell align="center"> {row?.maxLimit} </TableCell>
                                                            <TableCell align="center"> {row?.userName} </TableCell>
                                                            <TableCell align="center"> {row?.type} </TableCell>
                                                            <TableCell align="center"> {row?.volume} </TableCell>
                                                            <TableCell align="center"> {row?.status} </TableCell>
                                                        </TableRow>
                                                    )) :
                                                <TableRow>
                                                    <TableCell colSpan={8} align="center"> No Data Found </TableCell>
                                                </TableRow>
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <Pagination className='pagnation'
                                    count={totalPage}
                                    page={page}
                                    onChange={(event, value) => {
                                        setPage(value);
                                    }}
                                    variant="outlined"
                                    shape="rounded" />
                            </div>


                        </Grid2>
                    </Grid2>
                </Box>
            </Box>
        </div>
    );
};

export default P2pHistory;
